<h1>Verificador de autenticidade do certificado</h1>
<mat-card style="max-width: 470px;">
  <mat-card-content fxLayout="column">
    <form [formGroup]="form" fxLayout="column">
      <fieldset fxFlex="100%">
        <legend>Certificado</legend>
        <div fxLayout="column" class="mt-10">
          <mat-form-field appearance="outline">
            <mat-label>Código verificador</mat-label>
            <input
              matInput
              formControlName="codigo"
              maxlength="24"
              minlength="24"
              mask="AAAA-AAAA-AAAA-AAAA-AAAA"
              [dropSpecialCharacters]="false" />
          </mat-form-field>
        </div>
      </fieldset>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <button mat-raised-button color="primary" (click)="verificar()"><mat-icon>fingerprint</mat-icon> Verificar</button>
  </mat-card-actions>
</mat-card>
